/**************************************************************************************************/
/*   File: /src/app/shared/components/flag/flag.ts                                                */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Tue May 28 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Component, Input } from '@angular/core';

/**
 * The flag component
 */
@Component({
  selector: 'nwpl-frnt-flag',
  templateUrl: './flag.html',
  styleUrls: ['./flag.scss']
})
export class FlagComponent {

  /**
   * The isoCode
   */
  @Input() isoCode: string;

}
